export const PRINTFUL_SYNC_PRODUCTS_SYNC_FIELDS_LIST: any = [
    {attribute: "id", label: "Id", cssClass: 'text-center'},
    {
        attribute: "isProductsFetchCompleted",
        label: "Is Products Fetch Completed",
        cssClass: 'text-center',
        isBoolean: true
    },
    {
        attribute: "isVariantsFetchCompleted",
        label: "Is Variants Fetch Completed",
        cssClass: 'text-center',
        isBoolean: true
    },
    {attribute: "totalSyncProducts", label: "Total Sync Products", cssClass: 'text-center'},
    {attribute: "updatedOn", label: "Updated On", cssClass: 'text-center', isDate: true},
    /*{attribute: "batches", label: "Batches", cssClass: ''},
    {attribute: "paging", label: "Paging", cssClass: ''},*/
];


export const PRINTFUL_SYNC_PRODUCTS_SYNC_INPUT_FIELDS: any = [
    {attribute: "id", label: "Id", type: 'text', group: 'detail', cssClass: ''},
    {
        attribute: "isProductsFetchCompleted",
        label: "Is Products Fetch Completed",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "isVariantsFetchCompleted",
        label: "Is Variants Fetch Completed",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {attribute: "updatedOn", label: "Updated On", type: 'text', group: 'detail', cssClass: ''},
    /*{attribute: "batches", label: "Batches", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "paging", label: "Paging", type: 'text', group: 'detail', cssClass: ''},*/
];

export const PRINTFUL_SYNC_PRODUCTS_SYNC_BATCHES_FIELDS_LIST: any = [
    {attribute: "batchIndex", label: "Batch Index", cssClass: 'text-center'},
    {attribute: "status", label: "Status", cssClass: 'text-center'},
    {attribute: "totalSyncProducts", label: "Total Sync Products", cssClass: 'text-center'},
];
